import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useReducer,
} from "react";

import { DateTime } from "luxon";

import { months } from "Utilities/Date";

const FnrDateInput2Context = createContext();

const initialState = {
  month: "",
  day: "",
  year: "",
  activeField: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "setState": {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

function FnrDateInput2Provider({
  setDate,
  initialDate,
  // focusColor,
  // placeholder,
  // style,
  // killHoverStyles,
  showSave,
  onSave,
  children,
}) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { month, day, year } = state;

  const setState = useCallback(
    (payload) => {
      dispatch({ type: "setState", payload });
    },
    [dispatch]
  );

  useEffect(
    function setDateInParent() {
      if (!setDate) return;

      const dateObj = {};

      dateObj.month = month || "";
      dateObj.day = day || "";
      dateObj.year = year || "";

      setDate(dateObj);
    },
    [month, day, year]
  );

  useEffect(
    function setInitialDate() {
      if (!initialDate) return;
      let initialMonth, initialDay, initialYear;

      if (typeof initialDate === "string") {
        let date = DateTime.fromFormat(initialDate, "yyyy-MM-dd");
        if (!date.isValid) {
          console.error(
            "Invalid date format. Format must be yyyy-MM-dd. Or use an object with month, day, and year properties."
          );
          return;
        }
        initialMonth = date.month;
        initialDay = date.day;
        initialYear = date.year;
      } else if (typeof initialDate === "object") {
        initialMonth = initialDate.month;
        initialDay = initialDate.day;
        initialYear = initialDate?.year;
      } else {
        console.error(
          "initialDate has an invalid format. It's format must be a string with 'yyyy-MM-dd' format or an object with month and day properties.",
          initialDate
        );
      }

      if (initialYear) {
        setState({ year: initialYear });
      }
      if (initialMonth) {
        setState({
          month: initialMonth,
        });
      }
      if (initialDay) {
        setState({ day: initialDay });
      }
    },
    [initialDate]
  );

  return (
    <FnrDateInput2Context.Provider
      value={{
        state,
        dispatch,
        setState,
        setMonth: (month) => setState({ month }),
        setDay: (day) => setState({ day }),
        setYear: (year) => setState({ year }),
        setActiveField: (activeField) => setState({ activeField }),
        showSave,
        onSave,
      }}
    >
      {children}
    </FnrDateInput2Context.Provider>
  );
}

function useFnrDateInput2() {
  const context = useContext(FnrDateInput2Context);
  if (context === undefined) {
    throw new Error(
      `useFnrDateInput2 must be used within the FnrDateInput2Provider`
    );
  }
  return context;
}

export { FnrDateInput2Provider, useFnrDateInput2 };

// Path: fnreact/src/UI/FnrDateInput22/FnrDateInput22.js
